import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { TipoRespaldoCategoria } from '../_models/tipo-respaldo-categoria';

@Injectable({
  providedIn: 'root'
})
export class TipoRespaldoCategoriaService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/tiposRespaldosCategorias/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as TipoRespaldoCategoria[] ) );
  }

  listadoPorIdRespaldo( id: string ) {
    return this.httpClient.get( this.rutServicio + 'tipoRespaldo/' + id ).pipe( map( res => res as TipoRespaldoCategoria[] ) );
  }

  listadoPorCodigosRespaldos( codigo: string[] ) {
    return this.httpClient.post( this.rutServicio + 'tipoRespaldo/code/listIn', codigo  ).pipe( map( res => res as TipoRespaldoCategoria[] ) );
  }

  listadoPorCodigosRespaldosHabilitado( codigo: string[] ) {
    return this.httpClient.post( this.rutServicio + 'tipoRespaldo/code/listIn/enabled', codigo  ).pipe( map( res => res as TipoRespaldoCategoria[] ) );
  }

  obtenerPorCodigo( codigo: string ) {
    return this.httpClient.get( this.rutServicio + 'code/' + codigo ).pipe( map( res => res as TipoRespaldoCategoria ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as TipoRespaldoCategoria ) );
  }

  crear( regCrear: TipoRespaldoCategoria ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as TipoRespaldoCategoria ) );
  }

  actualizar( regActualizar: TipoRespaldoCategoria ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as TipoRespaldoCategoria ) );
  }

  buscar( str: string ) {
    return this.httpClient.get( this.rutServicio + 'buscar/' + str + '/' ).pipe( map( res => res as TipoRespaldoCategoria[] ) );
  }
}
